<template>
  <div id="article">
    <el-card class="box-card">
        <div slot="header" class="clearfix">
            <span>商品管理&nbsp;/&nbsp;商品列表</span>
        </div>
        <div style="display: flex;flex-wrap: wrap;align-items: center;">
            <Provinces @gain='gainSS'></Provinces>
            <el-select v-model="beginData.categoryId" placeholder="请选择所属分类" class="elinputs">
                <el-option
                    v-for="item in classify.class"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
            </el-select>
            <el-select v-model="beginData.delivery" placeholder="请选择配送方式" class="elinputs">
                <el-option
                    v-for="item in beginData.deliverys"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
            </el-select>
           <el-input class="elinputs" v-model="beginData.name" placeholder="请输入商品名称"></el-input>
           <el-input class="elinputs" v-model="beginData.supplier" placeholder="请输入供应商名称"></el-input>
            <el-button type="primary" element-loading-text="加载中..." element-loading-background="rgba(0, 0, 0, 0.4)" v-loading.fullscreen.lock="fullscreenLoading" @click="query">查询</el-button>
            <el-button type="info" @click='resets'>重置</el-button>
        </div>
        <div class="tit">
            <Reset @clkBtn='theBtn'></Reset>
            <Xlsx :name="formname"></Xlsx>
        </div>
        <el-table :data="tableData" id="exportTab" @selection-change="handleSelectionChange" border stripe style="width: 100%">
            <el-table-column type="selection" width="60"></el-table-column>
            <el-table-column type="index" label="序号" width="80" :index="1"></el-table-column>
            <el-table-column prop="name" label="商品名称" min-width="260"></el-table-column>
            <el-table-column prop="categoryName" label="所属分类" min-width="130"></el-table-column>
            <el-table-column prop="areasName" label="所属地区" min-width="130"></el-table-column>
            <el-table-column prop="deliveryAreaName" label="配送区域" min-width="130"></el-table-column>
            <el-table-column prop="supplierName" label="供应商" min-width="200"></el-table-column>
            <el-table-column label="是否预售" min-width="130">
                <template slot-scope="scope">
                    <p class="boldfont" v-if="scope.row.isSale" style="color:#67C23A">是</p>
                    <p class="boldfont" v-else style="color:#F56C6C">否</p>
                </template>
            </el-table-column>
            <el-table-column label="配送方式" min-width="130">
                <template slot-scope="scope">
                    <p class="boldfont" v-if="scope.row.delivery==1">冷链配</p>
                    <p class="boldfont" v-if="scope.row.delivery==2">常温配</p>
                </template>
            </el-table-column>
            <el-table-column label="缩略图" width="160">
                <template slot-scope="scope">
                    <viewer>
                        <img class="sfzimg" :src="imgUrl+scope.row.picUrl" />
                    </viewer>
                </template>
            </el-table-column>
            <el-table-column label="组图" width="400">
                <template slot-scope="scope">
                    <viewer>
                        <img class="sfzimg" v-for="(item,index) in scope.row.gallery.split(',')" :key="index" :src="imgUrl+item" />
                    </viewer>
                </template>
            </el-table-column>
            <el-table-column prop="retailPrice" label="原价" sortable min-width="130"></el-table-column>
            <el-table-column prop="discountPrice" label="优惠价" sortable min-width="130"></el-table-column>
            <el-table-column prop="price" label="结算价" sortable min-width="130"></el-table-column>
            <el-table-column prop="freightPrice" label="运费" sortable min-width="130"></el-table-column>
            <el-table-column prop="buyNum" label="销量（真）" sortable min-width="140"></el-table-column>
            <el-table-column prop="buyNumFalse" label="销量（假）" sortable min-width="140"></el-table-column>
            <el-table-column prop="stock" label="库存" sortable min-width="130"></el-table-column>
            <el-table-column prop="sortOrder" label="排序" sortable min-width="130"></el-table-column>
            <el-table-column label="状态" width="130">
                <template slot-scope="scope">
                    <p class="boldfont" v-if="scope.row.isOnSale" style="color:#67C23A">已上架</p>
                    <p class="boldfont" v-else style="color:#F56C6C">已下架</p>
                </template>
            </el-table-column>
            <el-table-column prop="addTime" label="添加时间" min-width="180"></el-table-column>
            <el-table-column prop="updateTime" label="修改时间" width="180"></el-table-column>
            <el-table-column label="操作" fixed="right" width="220">
                <template slot-scope="scope">
                <el-button size="mini" type="success" @click="handleEdit(1,scope.row,'articles:update')"><i class="el-icon-edit"></i> 编辑</el-button>
                <el-button size="mini" type="danger" @click="stop(scope.row,'articles:delete')"><i class="el-icon-delete"></i> 删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="paging">
            <span>
            共
            <i class="pagingNum">{{total}}</i> 条
            </span>
            <Paging :gopage="total" @pag="pag"></Paging>
        </div>
    </el-card>
    <el-dialog title="添加/编辑" :visible.sync="dialogFormVisible" width="60%" @close="dataClose">
        <el-form>
            <el-form-item label="* 所属分类：">
                <el-select v-model="mydata.categoryId" placeholder="请选择所属分类" class="newRegions">
                    <el-option
                    v-for="item in classify.class"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="* 所属地区：">
                <el-select v-model="sheng" placeholder="省份" @change="cksheng">
                    <el-option
                    v-for="item in shenglist"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
                <el-select v-model="shi" placeholder="城市" @change="ckshi" class="newRegions cty16">
                    <el-option
                    v-for="item in shilist"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="* 配送区域：">
                <el-select v-model="mydata.region" v-if='mydata.stat == 0' value-key="id" placeholder="全城" multiple @change="ckps">
                    <el-option
                    v-for="item in newRegion"
                    :key="item.id"
                    :label="item.name"
                    :value="item">
                    </el-option>
                </el-select>
                <p v-else @click="addstr=true">{{mydata.deliveryAreaName}} <span class="addstr"> 重新添加</span></p>
            </el-form-item>
            <el-form-item label="* 配送区域：" v-if="addstr">
                <el-select v-model="mydata.region" value-key="id" placeholder="全城" multiple @change="ckps">
                    <el-option
                    v-for="item in newRegion"
                    :key="item.id"
                    :label="item.name"
                    :value="item">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="* 商品名称：">
               <el-input placeholder="请输入商品名称" v-model="mydata.name" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="* 供应商：">
                <el-select v-model="mydata.supplierId" placeholder="请选择供应商" class="newRegions">
                    <el-option
                    v-for="item in classify.gys"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="* 食 材：">
                <el-select v-model="mydata.ingredientId" placeholder="请选择食材" class="newRegions">
                    <el-option
                    v-for="item in classify.foot"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="* 配送方式：">
                <el-select v-model="mydata.delivery" placeholder="请选择配送方式">
                    <el-option
                    v-for="item in beginData.deliverys"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="* 是否预售：">
                <el-select v-model="mydata.isSale" placeholder="请选择是否预售">
                    <el-option
                    v-for="item in beginData.presell"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="* 缩略图：" style='margin-bottom: 10px;'>
                <el-upload class="upload-demo" :action="URL" :limit="1" :on-remove="handleRemove" ref="upload"  :on-success="handleAvatarSuccess" :data="newobj" :file-list="mydata.iconUrls" name="multipartFile" :headers="newhead" list-type="picture">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">选择缩略图，推荐尺寸800*600px，大小100k以内</div>
                </el-upload>
            </el-form-item>
            <el-form-item label="* 组 图：" style='margin-bottom: 10px;'>
                <el-upload class="upload-demo" :action="URL" :limit="4" :on-remove="handleRemove1" ref="uploads" :on-success="handleAvatarSuccess1" :data="newobj" :file-list="mydata.picUrls" name="multipartFile" :headers="newhead" list-type="picture">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">选择组图（最多4张），推荐尺寸800*600px，大小100k以内</div>
                </el-upload>
            </el-form-item>
            <el-form-item label="* 详 情：" style="align-items: end;margin-top:16px">
                <editor-bar v-model="mydata.detail" :isClear="isClear" @change="change"></editor-bar>
            </el-form-item>
            <!-- <div style='min-height: 340px;'>
              <editor-bar v-model="mydata.detail" :isClear="isClear" @change="change"></editor-bar>
            </div> -->
            <el-form-item label="* 原 价：">
               <el-input placeholder="0.00" v-model="mydata.retailPrice" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="* 优惠价：">
               <el-input placeholder="0.00" v-model="mydata.discountPrice" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="* 结算价：">
               <el-input placeholder="0.00" v-model="mydata.price" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="* 运 费：">
               <el-input placeholder="0.00" v-model="mydata.freightPrice" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="* 销量（假）：">
               <el-input placeholder="请输入销量（假）" v-model="mydata.buyNumFalse" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="* 库 存：">
               <el-input placeholder="请输入库存" v-model="mydata.stock" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="* 权 重：">
               <el-input placeholder="0" v-model="mydata.sortOrder" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="* 状 态：">
                <el-radio v-model="mydata.isOnSale" label=true>上架</el-radio>
                <el-radio v-model="mydata.isOnSale" label=false>下架</el-radio>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible=false">取 消</el-button>
            <el-button type="primary" @click="puton()">确 定</el-button>
        </div>
    </el-dialog>
  </div>
</template>
<script>
import Provinces from "@/components/Provinces";
import Reset from "@/components/Reset";
import Xlsx from "@/components/Xlsx";
import EditorBar from '@/components/Richtext'
import Paging from '@/components/Paging';
export default {
  name: "articles",
  components: {
    Xlsx,
    EditorBar,
    Provinces,
    Reset,
    Paging
  },
  data() {
    return {
        beginData:{
            presell:[{name:'是',id:'true'},{name:'否',id:'false'}],
            deliverys:[{name:'冷链配',id:'1'},{name:'常温配',id:'2'}],
        },
        tableData: [],
        pageNum: 1,
        pageSize: 10,
        dialogFormVisible: false,
        details:[],
        userdata: {},
        total: 0,
        btn: [],
        areaId: "",
        fullscreenLoading: true,
        formname: JSON.stringify({name:'商品列表',hint:'articles:export'}),
        imgUrl: this.$Public.imgUrl,
        isClear: false,
        sheng:'',
        shi:'',
        shenglist:[],
        shilist:[],
        mydata:{presell:[{name:'是',id:'true'},{name:'否',id:'false'}],isOnSale:'true'},
        multipleSelection:[],
        URL:`${this.$Public.URL}/api-r/upload/uploadImg`,
        videoURL:`${this.$Public.URL}/api-e/upload/uploadVideo`,
        newobj:{type:3},
        newhead:{
                accessToken:JSON.parse(sessionStorage.getItem('userdata')).token
        },
        iconUrl:'',
        picUrl:[],

        // 哇
        newRegion:[],
        classify:{class:[],gys:[],foot:[]},
        addstr:false,
    };
  },
  created() {
    let btn = JSON.parse(sessionStorage.getItem("btn"));
    this.$set(this, "btn", btn);
    this.begin();
  },
  computed: {
    data() {
      return this.tableData;
    }
  },
  mounted() {
    let region = JSON.parse(localStorage.getItem('region'))
    region.forEach(x => {
        if(x.level==0){
            this.shenglist.push(x);
            this.sheng=x.id;
            this.shengName=x.name;
        }
    });
    if(this.userdata.level==0){
        this.$axios.post(`/api-r/area/getSubordinateAreaList`,this.$qs.stringify({areasId:region[0].id}),{headers:{accessToken:this.userdata.token}})
        .then(res=>{
            if(res.data.success){
                this.$set(this,'shilist',res.data.areaListInfoList)
            }
        })
    }else{
        region.forEach(x=>{
            if(x.level==1){
                this.shilist.push(x);
                this.shi=x.id;
                this.mydata.areasid = this.sheng +','+ x.id;
                this.mydata.areasName = this.shengName +','+ x.name;
            }
        })
        // 当前管理员如果是多个区域管理员或者以下
        if(this.shilist.length==1){
            this.shi=this.shilist[0].id
            this.mydata.areasId = this.sheng +','+ this.shilist[0].id
            this.$axios.post(`/api-r/area/getSubordinateAreaList`,this.$qs.stringify({areasId:this.shilist[0].id}),{headers:{accessToken:this.userdata.token}})
            .then(res=>{
                if(res.data.success){
                    if(res.data.success){
                        this.$set(this,'newRegion',res.data.areaListInfoList)
                    }
                }
            })
        }
    }
    // 查询下拉框选择
    this.getfoot();
    // 初始化地区ID和地区名称
    this.dataClose();
  },
  methods: {
    resets(){
        this.$router.push('/refresh')
    },
    //   判断当前点击的按钮
    theBtn(i){
        if(i==1){
            if(this.btn.indexOf('articles:add')==-1){
                return this.$message('抱歉，用户暂无该权限')
            }
            this.handleEdit(0)
        }else if(i==2){
            if(this.btn.indexOf('articles:update')==-1){
                return this.$message('抱歉，用户暂无该权限')
            }
            if(this.multipleSelection.length != 1){
                return this.$message('请勾选一项内容编辑')
            }
            this.handleEdit(1,this.multipleSelection[0])
        }else if(i==3){
            if(this.btn.indexOf('articles:delete')==-1){
                return this.$message('抱歉，用户暂无该权限')
            }
            this.choice()
        }else if(i==4){
            this.query()
        }
    },
    // 获取省市传入的id
    gainSS(i){
        this.beginData.areaId = i.id
    },
    //   获取供应商和食材和商品分类
    getfoot(){
        this.$axios.post(`/api-s/getAllGoodsCategory/${this.userdata.areasId}`,{},{ headers: { accessToken: this.userdata.token }})
        .then(res=>{
            this.classify.class = res.data.goodsCategoryInfos
        })
        this.$axios.post(`/api-s/getAllSupplier/${this.userdata.areasId}`,{},{ headers: { accessToken: this.userdata.token }})
        .then(res=>{
            this.classify.gys = res.data.supplierInfos
        })
        this.$axios.post(`/api-s/getAllIngredient/${this.userdata.areasId}`,{},{ headers: { accessToken: this.userdata.token }})
        .then(res=>{
            this.classify.foot = res.data.ingredientInfos
        })
    },
    change(val) {
      console.log(val)
    },
    //   多选配送区域获取选择城市
    ckps(){

    },
      // 图标处理
    handleRemove(file, fileList) {
        this.iconUrl = ''
    },
    handleAvatarSuccess(res, file) {
        this.iconUrl = res.url
    },
      // 图片处理，多图上传
    handleRemove1(file, fileList) {
        let arr = []
        if(fileList.length>0){
            fileList.forEach(x => {
                let reg = new RegExp(this.imgUrl,'g');
                let newImg = x.url.replace(reg,'');
                arr.push(newImg)
            });
        }
        this.picUrl = arr
    },
    handleAvatarSuccess1(res, file) {
        this.picUrl.push(res.url)
    },
    //   多选删除
    choice(){
        if(this.multipleSelection.length == 0){
            return this.$message('请至少选择一项删除')
        }
        let arr = []
        this.multipleSelection.forEach(x=>{
            arr.push(x.id)
        })
        this.$confirm('此操作将删除选中内容, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            let url = ``
            url = `/api-s/deleteGoods/${arr.join(',')}`
            this.$axios.post(url,{},{ headers: { accessToken: this.userdata.token }})
            .then(res=>{
                if(res.data.success==true){
                    this.$message({
                        type: 'success',
                        message: res.data.msg
                    });
                    this.begin();
                }else{
                    alert(res.data.msg)
                }
            })
        }).catch(() => {
            return
        });
    },
    // 关闭清空内容
    dataClose(){
        this.addstr = false
        if(this.shilist.length==1){
            this.mydata={presell:[{name:'是',id:'true'},{name:'否',id:'false'}],isOnSale:'true',areasId:this.sheng +','+ this.shilist[0].id,areasName:this.userdata.areasName}
        }else{
            this.shi = ''
            this.$set(this,'newRegion',[])
            this.mydata={presell:[{name:'是',id:'true'},{name:'否',id:'false'}],isOnSale:'true'}
        }
        this.picUrl = [];
        this.begin();
    },
    cksheng(val){
        this.$set(this,'shi','')
    },
    ckshi(val){
        this.mydata.areasId = this.sheng +','+ val
        let addName = ''
        this.shilist.forEach(x=>{
          if(val == x.id){
            addName = x.name
          }
        })
        this.mydata.areasName = this.shenglist[0].name +','+ addName
        // 新的查询区域
        let arr = [{name:'全城',id:888}]
        this.$axios.post(`/api-r/area/getSubordinateAreaList`,this.$qs.stringify({areasId:val}),{headers:{accessToken:this.userdata.token}})
        .then(res=>{
            if(res.data.success){
                res.data.areaListInfoList.forEach(x=>{
                    arr.push(x)
                })
            }
            this.newRegion = arr
        })
    },
    //   多选编辑
    handleSelectionChange(val) {
        this.multipleSelection = val;
    },
    //   确定
    puton(){
        // this.fullscreenLoading = true;
        if(this.mydata.areasId == undefined || this.mydata.areasId == ''){
            return this.$message.error('请选择所属地区')
        }
        if(!this.mydata.name||!this.mydata.supplierId||!this.mydata.ingredientId||!this.mydata.delivery||!this.mydata.isSale||!this.mydata.retailPrice||!this.mydata.discountPrice
        ||!this.mydata.price||!this.mydata.stock||!this.mydata.sortOrder||!this.mydata.detail||this.mydata.detail == "<p><br></p>"
        ){
            return this.$message.error('请完善必填信息')
        }
        if(!this.mydata.freightPrice|| this.mydata.freightPrice == ""){
            return this.$message.error('请先输入运费')
        }
        // 图片转换
        this.mydata.picUrl = this.iconUrl
        this.mydata.gallery = this.picUrl.join(',')

        // 判断是点击哪个
        let url = ``
        if(this.mydata.stat==0){
            url = `/api-s/addGoods`
            if(this.mydata.region.length<1){
                return this.$message('请选择所属地区')
            }
        }else if(this.mydata.stat==1){
            url = `/api-s/updateGoods`
        }
        // 如果是全城给后台传上一级市区
        if(this.mydata.region!=undefined){
            if(this.mydata.region.length>0){
                let arr1 = []
                let arr2 = []
                this.mydata.region.forEach(x=>{
                    arr1.push(x.name)
                    arr2.push(x.id)
                })
                this.mydata.deliveryAreaName = arr1.join(',')
                this.mydata.deliveryAreaId = arr2.join(',')
                arr2.forEach(x=>{
                    if(x == 888){
                        this.mydata.deliveryAreaName = '全城'
                        this.mydata.deliveryAreaId = this.shi
                    }
                })
            }
        }
        this.$axios.post(url,this.$qs.stringify(this.mydata),{ headers: { accessToken: this.userdata.token } })
        .then(res => {
            if(res.data.success){
                this.$message({
                    type: 'success',
                    message: res.data.msg
                });
                this.dialogFormVisible = false
                ///////////////////////
                this.$refs.upload.clearFiles();
                this.$refs.uploads.clearFiles();
            }else{
                this.$message({
                    message:res.data.msg,
                    type: 'warning'
                })
            }
        });
    },
    pag(val){
        this.pageNum = val.pageNum
        this.pageSize = val.pageSize
        this.fullscreenLoading = true;
        this.begin()
    },
    begin() {
      let userdata = JSON.parse(sessionStorage.getItem("userdata"));
      this.$set(this, "userdata", userdata);
      let data = this.$qs.stringify({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        areaId:this.beginData.areaId,
        categoryId:this.beginData.categoryId,
        delivery:this.beginData.delivery,
        deliveryAreaId:this.beginData.deliveryAreaId,
        name:this.beginData.name,
        supplier:this.beginData.supplier,
        adminAreasId: userdata.areasId
      });
      this.$axios.post(`/api-s/getGoodsList`, data, {headers: { accessToken: userdata.token }})
        .then(res => {
            this.fullscreenLoading = false;
            if(res.data.success){
                this.$nextTick(function(){  //不使用this.$nextTick()方法会报错
                    this.$set(this, "tableData", res.data.pageInfo.list);
                });
                this.$set(this, "total", res.data.pageInfo.total);
                this.$message({
                    type: 'success',
                    message: res.data.msg
                });
            }else{
              this.$message(res.data.msg)
            }
        });
    },
    handleEdit(i,row,hint) {
        if(hint&&this.btn.indexOf(hint)==-1){
            return this.$message('抱歉，用户暂无该权限')
        }
        if(i == 0){
            this.mydata.stat = i
        }else if(i == 1){
            let _this = this
            row.stat = i
            row.isOnSale += ''
            row.delivery += ''
            row.isSale += ''
            // 图片data还原
            this.iconUrl = row.picUrl
            this.picUrl = row.gallery.split(',')

            row.iconUrls = [{name:'分类图标',url:`${_this.imgUrl+row.picUrl}`}]
            let arr = []
            row.gallery.split(',').forEach(function (x,i) {
                arr.push({name:`组图${i+1}`,url:`${_this.imgUrl+x}`})
            })
            _this.ckshi(row.areasId.split(',')[1])
            row.picUrls = arr
            _this.sheng = Number(row.areasId.split(',')[0])
            _this.shi = Number(row.areasId.split(',')[1])
            _this.mydata = row
        }
        this.dialogFormVisible = true
    },
    // 删除
    stop(row,hint) {
        if(hint&&this.btn.indexOf(hint)==-1){
            return this.$message('抱歉，用户暂无该权限')
        }
        this.$confirm('此操作将删除该条内容, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            let url = ``
            url = `/api-s/deleteGoods/${row.id}`
            this.$axios.post(url,{},{ headers: { accessToken: this.userdata.token }})
            .then(res=>{
                if(res.data.success==true){
                    this.$message({
                        type: 'success',
                        message: res.data.msg
                    });
                    this.begin();
                }else{
                    alert(res.data.msg)
                }
            })
        }).catch(() => {
            return
        });
    },
    query() {
      this.fullscreenLoading = true;
      this.begin();
    }
  }
};
</script>
<style>
#article .editor{
    width: 100%;
}
.w-e-toolbar{
  flex-wrap: wrap;
}
#article .el-input__inner {
  margin: 10px 0;
}
#article .el-menu.el-menu--horizontal{
  margin-bottom: 14px;
}
#article .el-menu-item.is-active{
  background: none
}
#article .el-pagination__sizes .el-input__inner {
  margin: 0;
}
#article .el-tag{
  margin-right: 12px;
}
#article .el-select {
  /* margin: 0 8px; */
    width: 100%;
}
#article .el-upload__tip {
    display: inline-block;
    margin-left: 14px;
}
.input-new-tag{
  width: 20%
}
#article .el-upload-list--picture .el-upload-list__item {
    /* float: left;
    margin-right: 2%; */
}
#article .el-form-item__content {
    width: 100%;
    display: flex;
}
/* #article .el-form-item:first-child{
    align-items: end
} */
#article .el-table td,
.el-table th.is-leaf {
  text-align: center;
}
/* 暂无数据样式 */
#article .el-table__empty-text {
  display: block;
  width: 500px;
  height: 240px;
  padding-top: 126px;
  background: url(../../assets/img/nothing.svg) no-repeat 50%;
  color: #909399;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 12px;
}
#article .myxx .el-input--suffix .el-input__inner {
  border-bottom: 1px solid #dcdfe6;
  margin-bottom: 20px;
}
#article .myxx .el-input__inner {
  padding: 0 11px;
  border: none;
  border-radius: 0;
}
#article .el-dialog__body{
  min-height: 150px !important;
}
#article .el-dialog__body {
  height: 500px;
}
#article .el-form-item{
    display: flex;
    align-items: center;
    margin-bottom:0
}
#article .el-form-item__label{
    width: 188px;
}
.viewer-transition {
  z-index: 9999 !important;
}
</style>
<style scoped lang="scss">
.clearfix{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.tit {
  display: flex;
  justify-content: space-between;
  margin: 16px 0 24px;
}
.sfzimg {
  height: 48px;
  margin-right: 10px;
}
#help .myxx p {
  margin: 5px 0;
  font-size: 16px;
}
h5 {
  text-align: center;
  margin-top: 12px;
}
.f56 {
  background: #909399;
  color: #fff;
  border: 1px solid #909399;
}
.c23 {
  background: #409eff;
  color: #fff;
  border: 1px solid #409eff;
}
.tx{
      color: red;
    margin-left: 8px;
}
.summary>span:first-child{
    margin-right: 20px
}
.summary>span:first-child i{
    color:red
}
.summary>span:last-child i{
    color:green
}
.staimg{
    position: absolute;
    left: -26px;
    top: 10px;
    width: 18px;
}
.dtstat span{
    margin: 0 34px;
}
.addstr{
    margin-left: 16px;
    text-decoration: underline;
    color:red;
    cursor: pointer;
}
// .newRegion{
//     width: 46% !important;
// }
// .newRegions{
//     margin-left:4%
// }
</style>
